<template>
  <el-dialog class="radish-dia" title="批量修改" top="70px" :modal="false" :close-on-click-modal="false" :visible.sync="dialogVisible">
    <div class="radish-dia-body">
      列:
      <el-select v-model="checkedRow" filterable size="mini" placeholder="选择列" @change="handleChangeCheckedRow">
        <el-option v-for="v in types" :key="v.key" :label="v.key" :value="v.key"></el-option>
      </el-select>
      <el-select
        v-if="checkedRow === '细分职能' || checkedRow === '擅长方向'"
        v-model="category"
        filterable
        size="mini"
        placeholder="选择职能模块"
        @change="handleChangeCategory"
      >
        <el-option v-for="v in selectOption.职能模块" :key="v" :label="v" :value="v"></el-option>
      </el-select>

      <el-input
        v-show="inputKeys.includes(checkedRow)"
        v-model="updateValue"
        style="width:183px;"
        size="mini"
      ></el-input>
      <el-select
        v-show="mulKeys.includes(checkedRow)"
        v-model="mulUpdateValue"
        multiple
        filterable
        size="mini"
        @change="handleChangeVal"
      >
        <el-option v-for="v in selectOption[checkedRow]" :key="v" :label="v" :value="v"></el-option>
      </el-select>
      <el-select
        v-show="!mulKeys.includes(checkedRow) && !inputKeys.includes(checkedRow)"
        v-model="updateValue"
        filterable
        size="mini"
        @change="handleChangeVal"
      >
        <el-option v-for="v in selectOption[checkedRow]" :key="v" :label="v" :value="v"></el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">取 消</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="handleConfirm">确 定</div>

      <!-- <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button> -->
    </span>
  </el-dialog>
</template>
<script>
const { fieldsBasic } = require('../../../radish/src/constant/fields-detail.js')

export default {
  props: {
    thirdPerson: { type: Boolean, default: false },
  },
  data: function() {
    return {
      dialogVisible: false,
      types: [
        { key: '职能模块', inputType: 'select' },
        { key: '细分职能', inputType: 'select' },
        { key: '擅长方向', inputType: 'select' },
        { key: '地域', inputType: 'select' },
        { key: '职级', inputType: 'select' },
        { key: '业绩', inputType: 'select' },
        { key: '长期意向', inputType: 'select' },
      ],
      selectOption: {
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        地域: fieldsBasic.地域.options,
        职级: fieldsBasic.职级.options,
        业绩: fieldsBasic.业绩.options,
        长期意向: ['Y', 'N', 'F'],
      },
      checkedRow: '',
      category: '',
      updateValue: '',
      mulUpdateValue: [],
      mulKeys: ['职能模块', '细分职能', '擅长方向', '地域'],
      inputKeys: ['部门', '目前职位'],
      initValue: [],
      selectRow: [],
    }
  },
  async mounted() {
    if (!app.categories) {
      await app.getCats()
    }
    this.selectOption.职能模块 = app.categories.map(catrgory => catrgory.名称)
  },
  methods: {
    init() {
      this.category = ''
      this.mulUpdateValue = []
      this.updateValue = ''
      this.checkedRow = ''
      if (this.thirdPerson) {
        this.types = [
          { key: '职能模块', inputType: 'select' },
          { key: '细分职能', inputType: 'select' },
          { key: '擅长方向', inputType: 'select' },
          { key: '地域', inputType: 'select' },
          { key: '职级', inputType: 'select' },
          { key: '业绩', inputType: 'select' },
          { key: '长期意向', inputType: 'select' },
          { key: '部门', inputType: 'input' },
          { key: '目前职位', inputType: 'input' },
        ]
      } else {
        this.types = this.types.filter(v => v.inputType === 'select')
      }
    },
    getSameVal() {
      const arr = this.selectRow.filter(v => v.rid)
      if (arr.length < 1) return
      if (arr.length === 1) {
        const result = (arr[0] && arr[0][this.checkedRow]) || []
        this.mulUpdateValue = result
        this.initValue = JSON.parse(JSON.stringify(result))
      } else {
        const result = []
        const temp = (arr[0] && arr[0][this.checkedRow]) || []
        temp.forEach(v => {
          let allhave = true
          arr.forEach(val => {
            const array = val[this.checkedRow] || []
            const have = array.find(a => a === v)
            if (!have) allhave = false
          })
          if (allhave) result.push(v)
        })
        this.mulUpdateValue = result
        this.initValue = JSON.parse(JSON.stringify(result))
        console.log(this.mulUpdateValue)
      }
    },
    handleChangeVal(val) {
      console.log(val)
    },
    handleChangeCheckedRow() {
      const { checkedRow } = this
      if (this.mulKeys.includes(checkedRow)) {
        this.mulUpdateValue = []
        this.getSameVal()
      } else {
        this.updateValue = ''
      }
    },
    handleChangeCategory(val) {
      const category = app.categories.find(v => v.名称 === val)
      if (category) {
        this.selectOption.擅长方向 = category.擅长方向 || []
        this.selectOption.细分职能 = category.二级职能 || []
      }
    },
    handleConfirm() {
      if (this.mulKeys.includes(this.checkedRow)) {
        const deleteValue = this.initValue.filter(v => !this.mulUpdateValue.includes(v))
        const insertValue = this.mulUpdateValue.filter(v => !this.initValue.includes(v))
        this.$emit('confirm', { type: this.checkedRow, category: this.category, insertValue, deleteValue })
      } else {
        this.$emit('confirm', { type: this.checkedRow, data: this.updateValue })
      }
      this.dialogVisible = false
    },
    open(rows) {
      this.dialogVisible = true
      this.selectRow = rows
      this.init()
    },
  },
}
</script>
